export const NUM_REGEX = /\d+/;

/**
 * Matches a string that consists entirely of one or more decimal digits.
 * Used to validate numeric trade IDs extracted from URL search parameters.
 */
export const TRADE_ID_PATTERN = /^\d+$/;
